import styled from 'styled-components';

export default styled.div`
  display: inline-block;
  position: relative;
`;
